module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sm-editor"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6c0dc28"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AceEditor.vue
// module id = 22
// module chunks = 0